"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Editor/FieldList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* The field list beside the pages, grouped by page, with settings opening
 * inside it (screens 6 to 9 and 32). */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Form = require('web/components/Form');
var _HintToggle = require('web/components/HintToggle'); var _HintToggle2 = _interopRequireDefault(_HintToggle);

var _FieldSettings = require('./FieldSettings'); var _FieldSettings2 = _interopRequireDefault(_FieldSettings);
var _rules = require('./rules');

















const DETECT_HINT = 'Best effort. Works best on standard printed forms with clear lines and boxes. '
  + 'Check each yellow field before publishing.'

const READ_ONLY_NOTE = 'Only org admins can change a published form. Send it from any chat: +, then Send a form.'

const rowLabel = (f) => {
  const label = f.label.trim()
  if (f.type === 'rows') return `${label || 'Table'} · repeatable rows`
  if (f.filler === 'auto') return `${label || 'Date'} · when signed`
  return label
}

const inside = (f, table) => {
  const cx = f.box.x + f.box.w / 2
  const cy = f.box.y + f.box.h / 2
  return cx >= table.box.x && cx <= table.box.x + table.box.w && cy >= table.box.y && cy <= table.box.y + table.box.h
}

const FieldList = ({
  fields, pageCount, canEdit, progress, now, selected, onSelect, onChange, onRemove, onDetect, isStartingDetection,
}) => {
  const yellow = fields.filter(f => f.check).length
  const unlabelled = fields.filter(f => !f.label.trim()).length
  const finding = _rules.detectionHeader.call(void 0, progress, now)
  // A page detection already found empty isn't offered again.
  const filled = new Set(fields.map(f => f.page))
  const hasEmptyPage = Array.from({ length: pageCount }, (_, page) => page)
    .some(page => !filled.has(page) && _optionalChain([progress, 'access', _2 => _2[page], 'optionalAccess', _3 => _3.State]) !== 'none')

  let title
  let note = null
  if (!canEdit) {
    title = _rules.fieldsWord.call(void 0, fields.length)
    note = READ_ONLY_NOTE
  } else if (finding) {
    title = 'Finding fields…'
    note = 'This takes up to a minute. You can leave; the draft stays in the Library.'
  } else if (!fields.length) {
    title = 'No fields yet'
    note = onDetect
      ? 'Drag a field from the bar above onto the page, or let Auto-detect find them.'
      : 'Drag a field from the bar above onto the page.'
  } else if (yellow) {
    title = `${_rules.fieldsWord.call(void 0, fields.length)} found`
    note = `Check the ${yellow} yellow ${yellow === 1 ? 'field' : 'fields'}. Confirm, edit or delete each one.`
  } else {
    title = `${_rules.fieldsWord.call(void 0, fields.length)} · all checked`
    if (unlabelled) note = `Give ${unlabelled === 1 ? 'the last field' : `the other ${unlabelled} fields`} a label.`
    else if (fields.some(f => f.type === 'rows')) note = 'Tables with repeatable rows are marked in green.'
  }

  return (
    _react2.default.createElement('aside', { className: "forms-editor--list", 'aria-label': "Fields", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
      , _react2.default.createElement('div', { className: "forms-editor--list-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
        , _react2.default.createElement('h2', { className: "forms-editor--list-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}},  title )
        ,  note && _react2.default.createElement('p', { className: "forms-editor--list-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}},  note ) 
        ,  canEdit && !finding && hasEmptyPage && onDetect && (
          _react2.default.createElement('div', { className: "forms-editor--detect", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
            , _react2.default.createElement(_Form.Button, { isOutlined: true, isLoading: isStartingDetection, onClick: onDetect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
              ,  isStartingDetection ? 'Starting…' : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('span', { 'aria-hidden': "true", className: "forms-editor--detect-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, "✨"), "Auto-detect fields" ) 
            )
            , _react2.default.createElement(_HintToggle2.default, { place: "bottom", hint: DETECT_HINT, mobileShow: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}} )
          )
        )
      )
      , _react2.default.createElement('div', { className: "forms-editor--list-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
        ,  Array.from({ length: pageCount }, (_, page) => {
          const onPage = fields.filter(f => f.page === page)
          const pageNote = canEdit ? _rules.pageProgressNote.call(void 0, progress[page], now) : null
          if (!canEdit && !onPage.length) return null
          return (
            _react2.default.createElement('section', { key: page, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
              , _react2.default.createElement('h3', { className: "forms-editor--list-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}, "Page "
                 ,  page + 1 
                ,  pageNote && (
                  _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, pageNote.isProblem && 'forms-editor--problem'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, " · "  ,  pageNote.text )
                )
              )
              ,  onPage.map(f => {
                const isOpen = _optionalChain([selected, 'optionalAccess', _4 => _4.id]) === f.id
                return (
                  _react2.default.createElement('div', { key: f.id, className: _classBuilder2.default.call(void 0, 'forms-editor--row-wrap', isOpen && 'forms-editor--row-wrap--open'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
                    , _react2.default.createElement('button', {
                      type: "button",
                      'aria-expanded': canEdit ? isOpen : undefined,
                      className: _classBuilder2.default.call(void 0, 
                        'forms-editor--row',
                        f.check && 'forms-editor--row--check',
                        f.type === 'rows' && 'forms-editor--row--rows',
                      ),
                      onClick: () => onSelect(f), __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}

                      , _react2.default.createElement('span', { className: "forms-editor--type", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
                        ,  f.check ? '!' : _rules.TYPE_NAMES[f.type].charAt(0) 
                      )
                      , _react2.default.createElement('span', { className: "forms-editor--row-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
                        ,  rowLabel(f) || _react2.default.createElement('span', { className: "forms-editor--problem", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}, "Add a label"  ) 
                        ,  f.required && f.filler !== 'auto' && _react2.default.createElement('span', { className: "forms-editor--required", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, " *" ) 
                        ,  f.check && _react2.default.createElement('span', { className: "forms-editor--sr", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, " (needs a check)"   ) 
                      )
                      , _react2.default.createElement('span', { className: "forms-editor--row-filler", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}},  _rules.FILLER_NAMES[f.filler] )
                    )
                    ,  canEdit && isOpen && selected && (
                      _react2.default.createElement(_FieldSettings2.default, {
                        key: f.id,
                        field: f,
                        openedType: selected.openedType,
                        staffInTable: f.type === 'rows'
                          ? fields.filter(o => o.page === f.page && o.filler === 'staff' && inside(o, f))
                          : [],
                        onChange: onChange,
                        onRemove: () => onRemove(f.id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
                      )
                    )
                  )
                )
              })
            )
          )
        })
      )
      ,  canEdit && (
        _react2.default.createElement('p', { className: "forms-editor--list-foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, "Field types." ), " Text, Date, Time, Checkbox, Choice (pick one), Initials (typed, 2 to 4 letters), Signature (typed full name), Repeatable rows (a table the family adds rows to)."

        )
      )
    )
  )
}

exports. default = FieldList
